/**
 * PujcovnaSubtabs — the section switch of the rental module (Přehled = today's board, Rezervace = the home, Vozidla = the fleet, Úhrady = the payments overview, Správa),
 * one component for every page of it. Rezervace, Vozidla and Úhrady are for every reader of the module, Správa for its admins.
 */

import { useNavigate } from '@tanstack/react-router';
import { Subtabs } from '@/components/Subtabs';
import { useModuleAccess } from '@/lib/permissions';

export type PujcovnaSekce = 'prehled' | 'rezervace' | 'vozidla' | 'uhrady' | 'sprava';

const PATH: Record<PujcovnaSekce, string> = {
  prehled: '/pujcovna/prehled',
  rezervace: '/pujcovna/rezervace',
  vozidla: '/pujcovna/vozidla',
  uhrady: '/pujcovna/uhrady',
  sprava: '/pujcovna/sprava',
};

export function PujcovnaSubtabs({ active }: { active: PujcovnaSekce }) {
  const navigate = useNavigate();
  const { can, resolved } = useModuleAccess();
  // Hidden until membership resolves (a flash of tabs the member may not have).
  if (!resolved || !can('pujcovna', 'read')) return null;
  const items: Array<{ value: PujcovnaSekce; label: string }> = [
    { value: 'prehled', label: 'Přehled' },
    { value: 'rezervace', label: 'Rezervace' },
    { value: 'vozidla', label: 'Vozidla' },
    { value: 'uhrady', label: 'Úhrady' },
    ...(can('pujcovna', 'admin') ? [{ value: 'sprava' as const, label: 'Správa' }] : []),
  ];
  return (
    <Subtabs<PujcovnaSekce>
      aria-label="Půjčovna — sekce"
      value={active}
      onChange={(next) => {
        if (next !== active) navigate({ to: PATH[next] });
      }}
      items={items}
    />
  );
}
